import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading3, heading5, heroDescription, linkButtonText },
} = mixins;

export const CheckboxLabel = styled.label``;
export const CheckboxInput = styled.input`
  display: none;
`;

export const CheckboxContainer = styled.div`
  line-height: 24px;
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 5px;

  ${CheckboxInput} {
    opacity: 0;
  }

  ${CheckboxLabel} {
    position: relative;
    display: inline-block;
    /*16px width of fake checkbox + 6px distance between fake checkbox and text*/
    padding-left: 25px;
  }

  ${CheckboxLabel}::before{
    position: absolute;
    content: "";
    
    /*Needed for the line-height to take effect*/
    display: inline-block;
  }

  ${CheckboxLabel}::after {
    position: absolute;
    content: "";
    
    /*Needed for the line-height to take effect*/
    display: inline-block;
  }

  ${CheckboxLabel}::before {
    height: 16px;
    width: 16px;
    
    border: 1px solid;
    left: 0px;
    
    /*(24px line-height - 16px height of fake checkbox) / 2 - 1px for the border
     *to vertically center it.
     */
    top: 3px;
  }

  ${CheckboxLabel}::after {
    height: 5px;
    width: 9px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    
    transform: rotate(-45deg);
    
    left: 4px;
    top: 7px;
  }

  ${CheckboxLabel} {
    &::after  {
      content: none;
    }
  }

  &.checked ${CheckboxLabel} {
    &::after {
      content: "";
    }
  }

  ${CheckboxInput}:focus + ${CheckboxLabel}::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;